import { render, staticRenderFns } from "./SamplePrep.vue?vue&type=template&id=161b11e5"
import script from "./SamplePrep.vue?vue&type=script&lang=js"
export * from "./SamplePrep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports